export default "__VITE_ASSET__D2bHaFdo__"